export var PAGE_TYPE = 'article';
